import { ApplicationConfig, importProvidersFrom, inject, PLATFORM_ID } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { isPlatformBrowser, isPlatformServer, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { provideClientHydration } from '@angular/platform-browser';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes, 
      // Using PathLocationStrategy (clean URLs without #)
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      })
    ),
    // Explicitly provide PathLocationStrategy to ensure clean URLs
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(),
    // importProvidersFrom(HttpClientModule),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService
  ]
};